import { render, staticRenderFns } from "./FaceGuideOverlay.vue?vue&type=template&id=408b6937&scoped=true"
import script from "./FaceGuideOverlay.vue?vue&type=script&lang=js"
export * from "./FaceGuideOverlay.vue?vue&type=script&lang=js"
import style0 from "./FaceGuideOverlay.vue?vue&type=style&index=0&id=408b6937&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b6937",
  null
  
)

export default component.exports